import React from "react";
import RefundTicketForm from "../components/RefundTicket/RefundTicketForm";
import "../components/RefundTicket/index.css";
const RefundTicketPage = () => {
  return (
    <>
      <RefundTicketForm />
    </>
  );
};

export default RefundTicketPage;
